import { EMemberRole, TBaseEntity } from './common';
import { TDocument } from './section';
import { commentsTabs } from '../constants';

export type TResponsibleEngineer = {
  fullName: string;
  id: number; // id в нашей системе
  position: EMemberRole;
  userId: number; // id в системе 
};

export type TCommentShortData = {
  id: number;
  documentation: TDocument;
  kitName: string;
  title: string;
  number: string;
  project: TBaseEntity;
  createdAt: string;
  updateTime?: string;
  version: number;
  versionList?: TDocument[];
  responsibleEngineers?: TResponsibleEngineer[];
  partnersChatId?: number;
  internalChatId?: number;
};

export type TCommentData = TCommentShortData & {
  descriptionDecision?: string;
  description: string;
  isFullReject?: boolean;
  isResponsible?: boolean;
  isArchitecturalSupervision?: boolean;
  contractorShortName?: string;
  startAgreement?: boolean;
  responsibleId?: number;
};

type TFilter = {
  projects: TBaseEntity[];
  kits: TBaseEntity[];
};

export type TCommentsFiltersData = {
  new: TFilter;
  inProgress: TFilter;
  reject: TFilter;
  workedOut: TFilter;
};

export type TCommentsTab = typeof commentsTabs[number];

export type TCommentDecisionPayload = {
  decisionAction: ECommentDecisionAction;
  responsibleRole?: EMemberRole;
  descriptionDecision: string;
  agreedEngineers?: EMemberRole[];
};

export type TCommentStartApproveProcessPayload = {
  typeAgreement: ECommentTypeAgreement;
  action: ECommentApproveProcessAction;
  descriptionAgreement: string;
  exceptedDate: string;
};

export type TResponsibleEngineerWithStatus = TResponsibleEngineer & {
  status: EResponsibleEngineerApproveStatus;
  canApprove?: boolean;
};

export type TCommentApproveProcessDetails = {
  agreement: TCommentStartApproveProcessPayload;
  responsible: TResponsibleEngineerWithStatus[];
};

export enum ECommentAction {
  APPROVE = 'approve_canceled', // Подтвердить отклонение
  RETURN_TO_WORK = 'return_in_work', // Вернуть в работу
  REJECT = 'reject', // Отклонить
}

export enum ECommentDecisionAction {
  TRANSFER_FOR_DECISION = 'transfer_responsible_for_decision', // Передать ответственным для принятия решения
  REMOVE_IN_WORKING_ORDER = 'remove_in_working_order', // Снять в рабочем порядке
  REJECT = 'reject', // Отклонить
}

export enum ECommentStatus {
  NEW = 'new', // Новое
  IN_PROGRESS = 'in_progress', // В работе
  BE_AGREED = 'be_agreed', // На согласовании
  REJECT = 'reject', // Отклонено
  WORKED_OUT = 'worked_out', // Отработано
}

export enum ECommentTypeAgreement {
  DESIGN_ERROR = 'design_error', // Ошибка проектирования
  ADDITIONAL_REQUIREMENT = 'additional_requirement', // Дополнительное требование
  CLARIFICATION_DECISIONS = 'clarification_decisions', // Уточнение решений
}

export enum ECommentApproveProcessAction {
  REJECT = 'reject', // Отклонить
  EDIT_REQUEST = 'create_request_on_edit', // Создать заявку на ИЗМ
}

export enum EResponsibleEngineerApproveStatus {
  WAIT = 'wait', // Ожидается согласование
  AGREED = 'agreed', // Согласовано
}
